/* eslint react/prop-types: 0 */

import _ from 'lodash';
import {
    getZipCodeRegexByCountry,
    getPhoneNumberRegexByCountry,
} from './CountryUtils';

export const ArrayToOptions = (array) =>
    array.map((arrayValue) => ({
        label: arrayValue,
        value: arrayValue,
    }));

export const convertBooleanToYesNo = (value, defaultValue = '-') => {
    if (value === null || value === undefined) {
        return defaultValue;
    }
    return value ? 'Yes' : 'No';
};

export const concatenateArrayElements = (array, field) => {
    if (field) {
        return array
            ? _.uniq(array.map((element) => _.get(element, field, ''))).join(
                  ', '
              )
            : '';
    }
    return array ? _.uniq(array).join(', ') : '';
};

export const refactorLinkedInUrl = (linkedIn) => {
    if (!linkedIn) return '/';

    if (linkedIn.includes('://')) {
        return linkedIn;
    }
    return `//${linkedIn}`;
};

/**
 * explicitly checking value for null instead of value ? undefined : 'Required' to support check on boolean values
 * where false can be valid value.
 * */
export const requiredUtil = (value) => (value != null ? undefined : 'Required');

export const requireTrueUtil = (errorMsg) => (value) =>
    value === true ? undefined : errorMsg;

export const validateArrayUtil = (value) =>
    value.length === 0 ? 'Required' : undefined;

export const validateAndRequiredAlphaNumericTextUtil = (value) => {
    if (value) {
        return /^[\dA-Za-z]+$/.test(value)
            ? undefined
            : 'Alphanumeric characters only, no spaces/symbols';
    }
    return 'Required';
};

// eslint-disable-next-line consistent-return
export const validateEmailUtil = (value) => {
    if (value) {
        return /\S+@\S+\.\S+/.test(value) ? undefined : 'Invalid Format';
    }
};

export const validateAndRequiredEmailUtil = (value) => {
    if (value) {
        return /\S+@\S+\.\S+/.test(value) ? undefined : 'Invalid Format';
    }
    return 'Required';
};

// eslint-disable-next-line consistent-return
export const validateNumberUtil = (value) => {
    if (value) {
        return /^\d+(\.\d{1,10})?$/.test(String(value))
            ? undefined
            : 'Invalid Number';
    }
};

export const validateAndRequiredNumberUtil = (value) => {
    if (value) {
        return /^\d+(\.\d{1,10})?$/.test(String(value))
            ? undefined
            : 'Invalid Number';
    }
    return 'Required';
};

// eslint-disable-next-line consistent-return
export const validateDateUtil = (value) => {
    if (value) {
        const date = new Date(value);
        const currentDate = new Date();
        return date > currentDate || date.getFullYear() < 1900
            ? 'Invalid Date'
            : undefined;
    }
};

export const validateAndRequiredDateUtil = (value) => {
    if (value) {
        const date = new Date(value);
        const currentDate = new Date();
        return date > currentDate || date.getFullYear() < 1900
            ? 'Invalid Date'
            : undefined;
    }
    return 'Required';
};

const monthDiff = (startDate, endDate) => {
    let months;
    months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += endDate.getMonth();
    return months;
};

export const validateStartDateBeforeEndDate = (employers) => {
    if (!_.isEmpty(employers)) {
        const result = employers.find(
            ({ startDate, endDate }) => new Date(endDate) < new Date(startDate)
        );
        if (result) {
            return 'Start Date should be less than End Date. Kindly check all the dates entered.';
        }
    }
    // eslint-disable-next-line unicorn/no-useless-undefined
    return undefined;
};

export const validateSevenYearEmploymentData = (employers) => {
    if (!_.isEmpty(employers)) {
        let monthCount = 0;
        _.forEach(employers, (value) => {
            monthCount += monthDiff(
                new Date(value.startDate),
                value.endDate ? new Date(value.endDate) : new Date()
            );
        });
        if (monthCount < 7 * 12) {
            return 'Please fill Seven years employment data.';
        }
        // eslint-disable-next-line unicorn/no-useless-undefined
        return undefined;
    }
    return 'Please fill Seven years employment data.';
};

export const validateDates = (employers) => {
    const startDateBeforeEndDate = validateStartDateBeforeEndDate(employers);
    const sevenYearEmploymentData = validateSevenYearEmploymentData(employers);

    if (!startDateBeforeEndDate && !sevenYearEmploymentData) {
        return;
    }
    // eslint-disable-next-line consistent-return
    return startDateBeforeEndDate ?? sevenYearEmploymentData;
};

export const validateAndRequiredZipCodeUtil = (value, country) => {
    const zipCodeRegex = getZipCodeRegexByCountry(country);
    if (value) {
        return zipCodeRegex.test(value) ? undefined : 'Invalid Code';
    }
    return 'Required';
};

export const validateAndRequiredPhoneNumberUtil = (value, country) => {
    const phoneNumberRegex = getPhoneNumberRegexByCountry(country);
    if (!value) {
        return 'Required';
    }
    if (_.size(value) > 32) {
        return 'No more than 32 characters allowed';
    }
    return phoneNumberRegex.test(value) ? undefined : 'Invalid Number';
};

const SWIFT_CODE_REGEX = /^[A-Z]{6}[\dA-Z]{2}([\dA-Z]{3})?$/;

export const validateSwiftCodeUtil = (value) =>
    value && SWIFT_CODE_REGEX.test(value);
